import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Breadcrumb, Row, Card, Skeleton, Button } from 'antd';
import OneRowData from 'components/OneRowData';
import { Link } from 'react-router-dom';
import Table from 'components/Table/Table.component';
import NewFilter from 'components/NewFilter/NewFilter.container';
import { FILTER_TYPE } from 'shared/constant';
import {
  formatDateTimeMonth12H,
  formatDateTimeMonthDetail,
  formatIDR,
} from 'shared/utils/StringUtil';
import { STATE, STATUS } from '../../constant/GoldDefaultVar';

import { initialState } from '../../redux/reducers/goldReducer';
import goldRoute from '../../route';
import text from './TransactionDetail.page.translation';
import './TransactionDetail.style.less';

export default class TransactionDetail extends PureComponent {
  componentDidMount() {
    const id = get(this.props, 'match.params.id');
    const paginationUrl = this.buildPaginationUrl(
      initialState.trxHistoryFilter,
    );
    this.props.getAccountDetail(id);
    this.props.getAccountTrx(paginationUrl);
  }

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={goldRoute.TRANSACTION_LOG}>
              {formatMessage(text.page)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.title)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  leftTransactionData = data => {
    const setLeftData = [
      {
        label: 'DANA Public ID',
        value: get(data, 'dana_public_id', '-'),
      },
      {
        label: 'Customer Name',
        value: get(data, 'name', '-'),
      },
      {
        label: 'Current Gold Balance',
        value: get(data, 'current_gold_balance_in_gram')
          ? `${get(data, 'current_gold_balance_in_gram')} gram`
          : '-',
      },
      {
        label: 'Partner KYC Status',
        value: get(data, 'partner_kyc_status', '-').toLowerCase(),
        valueCustomClass:
          get(data, 'partner_kyc_status') === 'VERIFIED'
            ? 'value green'
            : 'value orange',
      },
    ];

    const setRowData = Object.keys(setLeftData).map(
      this.rowData.bind(this, setLeftData),
    );

    return setRowData;
  };

  rightTransactionData = data => {
    const setRightData = [
      {
        label: 'Gain/Loss Amount',
        value: get(data, 'profit') ? formatIDR(get(data, 'profit')) : '-',
      },
      {
        label: 'Gain/Loss %',
        value: get(data, 'profit_percentage')
          ? `${get(data, 'profit_percentage').slice(0, -2)}%`
          : '-',
      },
      {
        label: 'Last Update At',
        value: get(data, 'last_updated_at')
          ? formatDateTimeMonth12H(get(data, 'last_updated_at'))
          : '-',
      },
      {
        label: 'Service Bind Time',
        value: get(data, 'service_bind_time')
          ? formatDateTimeMonth12H(get(data, 'service_bind_time'))
          : '-',
      },
      {
        label: 'Service Consent Time',
        value: get(data, 'service_consent_time')
          ? formatDateTimeMonth12H(get(data, 'service_consent_time'))
          : '-',
      },
    ];

    const setRowData = Object.keys(setRightData).map(
      this.rowData.bind(this, setRightData),
    );

    return setRowData;
  };

  rowData = (data, key) => <OneRowData key={key} data={data[key]} />;

  getRowKey = record => record.id;

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];

      switch (element.key) {
        case 'created_at':
          result += `&created_at_from=${encodeURIComponent(
            value,
          )}&created_at_until=${encodeURIComponent(element.inputValue[1])}`;
          break;

        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  handleChangePage = page => {
    const { trxHistoryFilter, filterValue, getAccountTrx } = this.props;
    const newPagination = {
      ...trxHistoryFilter,
      page_num: page,
    };
    const paginationUrl = this.buildPaginationUrl(newPagination);
    const paramUrl = this.buildGetParamUrl(filterValue);
    getAccountTrx(paginationUrl, paramUrl);
  };

  renderTransactionInfo = () => {
    // TODO: Get data info if loading render skeleton
    const {
      intl: { formatMessage },
      loading,
      data,
    } = this.props;

    return (
      <Card title={formatMessage(text.title)}>
        <Row type="flex">
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {this.leftTransactionData(data)}
            </Skeleton>
          </Card.Grid>
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {this.rightTransactionData(data)}
            </Skeleton>
          </Card.Grid>
        </Row>
      </Card>
    );
  };

  updateTransactionTable = newFilterValue => {
    const { getAccountTrx, trxHistoryFilter } = this.props;

    const newPagination = {
      ...trxHistoryFilter,
      page_num: 1,
    };
    const paginationUrl = this.buildPaginationUrl(newPagination);
    const paramUrl = this.buildGetParamUrl(newFilterValue);

    getAccountTrx(paginationUrl, paramUrl);
  };

  renderTransactionTransition = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Card title={formatMessage(text.transition)}>
        {this.renderTransitionTable()}
      </Card>
    );
  };

  _renderFormatedColumn = (format, item) => t => format(get(t, item));

  getStatusColor = status => {
    let color = '';
    let colorCode = '';
    switch (status) {
      case STATE[0]:
      case STATE[1]:
      case STATE[2]:
      case STATE[3]:
        color = 'orange';
        colorCode = '#ff9e30';
        break;
      case STATE[4]:
      case STATE[5]:
      case STATE[6]:
        color = 'red';
        colorCode = '#fa6060';
        break;
      case STATE[7]:
      case STATE[8]:
        color = 'green';
        colorCode = '#5ace70';
        break;
      default:
        color = 'grey';
        colorCode = '#9b9b9b';
        break;
    }

    return { color, colorCode };
  };

  renderState = (_text, record) => (
    <span className={`status ${this.getStatusColor(record.state).color}`}>
      {record.state}
    </span>
  );

  renderColumns = () => [
    {
      title: 'Merchant Order ID',
      key: 'sales_order_public_id',
      width: 170,
      align: 'center',
      dataIndex: 'sales_order_public_id',
    },
    {
      title: 'State',
      key: 'state',
      width: 150,
      align: 'center',
      render: this.renderState,
    },
    {
      title: 'Status',
      key: 'status',
      width: 150,
      align: 'center',
      dataIndex: 'status',
    },
    {
      title: 'Timestamp',
      key: 'created_at',
      width: 200,
      align: 'center',
      render: this._renderFormatedColumn(
        formatDateTimeMonthDetail,
        'created_at',
      ),
    },
    {
      title: 'Extend Info',
      key: 'additional_info',
      width: 400,
      dataIndex: 'additional_info',
    },
  ];

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  buildPaginationUrl = trxFilter => {
    const id = get(this.props, 'match.params.id');
    let result = `dana_public_id=${id}`;
    result += `&page_size=${encodeURIComponent(trxFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(trxFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(trxFilter.page_num)}`;

    return result;
  };

  renderTransitionTable = () => {
    const {
      intl: { formatMessage },
      trxHistoryList,
      trxHistoryFilter,
      loadingTrx,
    } = this.props;

    const pageSize = get(trxHistoryFilter, 'page_size');
    const pageCount = get(trxHistoryFilter, 'page_count');
    const pageNum = get(trxHistoryFilter, 'page_num');
    const totalItem = pageSize * pageCount;
    const tableColumns = this.renderColumns(formatMessage);
    const scrollX = this.getColumnsScrollX(tableColumns);

    const options = [
      {
        label: 'Merchant Order ID',
        value: 'sales_order_public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Status',
        value: 'status',
        type: FILTER_TYPE.RADIO,
        options: STATUS.map(status => ({
          label: status,
          value: status,
        })),
      },
      {
        label: 'State',
        value: 'state',
        type: FILTER_TYPE.RADIO,
        options: STATE.map(state => ({
          label: state,
          value: state,
        })),
      },
      {
        label: 'Timestamp',
        value: 'created_at',
        options: {
          showTime: true,
          format: 'YYYY-MM-DDTHH:mm:ssZ',
        },
        type: FILTER_TYPE.RANGE_PICKER,
      },
    ];

    return (
      <div className="table-wrapper">
        <NewFilter
          options={options}
          onAddFilter={this.updateTransactionTable}
          onRemoveFilter={this.updateTransactionTable}
        />
        <Table
          bordered
          columns={tableColumns}
          dataSource={trxHistoryList}
          pagination="true"
          rowKey={this.getRowKey}
          rowClass="striped-table"
          loadingValue={loadingTrx}
          totalItem={totalItem}
          currentPage={pageNum}
          changePage={this.handleChangePage}
          scrollX={scrollX}
        />
      </div>
    );
  };

  render() {
    return (
      <div className="main-content transaction-detail-wrapper">
        {this.renderBreadCrumb()}
        <div className="white-box-wrapper">
          {this.renderTransactionInfo()}
          {this.renderTransactionTransition()}
          <Button type="default" className="btn" htmlType="submit">
            <Link to={goldRoute.TRANSACTION_LOG}>Back</Link>
          </Button>
        </div>
      </div>
    );
  }
}

TransactionDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  getAccountDetail: PropTypes.func,
  getAccountTrx: PropTypes.func,
  data: PropTypes.object,
  trxHistoryList: PropTypes.array,
  loadingTrx: PropTypes.bool,
  trxHistoryFilter: PropTypes.object,
  filterValue: PropTypes.object,
};
